/**
 * Delivery enums shared across sp-deliveries-mgmt-api and its consumers.
 *
 * The response shapes these enums appear in are declared once as DTOs in
 * `@libs/common-node/spr` so a DMA field or Swagger change fails at compile
 * time. Values here match the DB CHECK constraints on `main.deliveries` /
 * `main.delivery_items`.
 */

export enum DeliveryStatus {
    Active = 'ACTIVE',
    Skipped = 'SKIPPED',
    Cancelled = 'CANCELLED',
    Ordered = 'ORDERED',
    Fulfilled = 'FULFILLED',
    Failed = 'FAILED',
    SystemError = 'SYSTEM_ERROR',
    Removed = 'REMOVED',
}

export enum DeliveryItemStatus {
    Active = 'ACTIVE',
    Cancelled = 'CANCELLED',
}

export enum DeliveryItemMovementReason {
    OutOfStock = 'OUT_OF_STOCK',
}

export enum DeliveryFulfillmentMethod {
    Sth = 'STH',
    Bopis = 'BOPIS',
    Sdd = 'SDD',
}

export enum DeliveryPaymentType {
    Cc = 'CC',
    Paypal = 'PAYPAL',
}

export enum DeliveryFulfillmentEventType {
    DeliveryFulfillmentDue = 'DELIVERY_FULFILLMENT_DUE',
}
